/** API route map: URLS.Controller.PTOTimeOff */
export const PTOTimeOff = {
      Name: 'PTOTimeOff/',
      GetPtoRequests: 'get-all-employee-pto-requests',
      EmployeePtoPolicies: 'get-employee-assigned-policies',
      AddEmployeePtoRequest: 'add-employee-paid-time-off',
      GetAllClientGuests: 'get-all-guests',
      addPtoRequestComment: 'add-pto-request-comment',
      GetPtoRequestComment: 'get-paid-time-comment',
      GetProfileSummary: 'get-header-summary',
      EmployeeRequestedPto: 'get-employee-requested-pto',
      GetEmployeePtoRequests: 'get-employee-pto-requests',
      UpdateEmployeePtoRequest: 'update-employee-paid-time-off',
};
